import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"

class PaymentMasterService {
  public async getListPhase(params): Promise<any> {
    const res = await http.get("api/services/app/PaymentPhase/GetList", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async getPhase(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PaymentPhase/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }
  public async createOrUpdatePhase(body: any) {
    const res = await http.post(
      "api/services/app/PaymentPhase/CreateOrUpdate",
      body
    )
    return res.data.result
  }
  public async activatePhase(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PaymentPhase/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  //

  public async getListPeriod(params): Promise<any> {
    const res = await http.get("api/services/app/PaymentPeriod/GetList", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async getPeriod(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PaymentPeriod/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }
  public async createOrUpdatePeriod(body: any) {
    const res = await http.post(
      "api/services/app/PaymentPeriod/CreateOrUpdate",
      body
    )
    return res.data.result
  }
  public async activatePeriod(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PaymentPeriod/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getAllPhase(params: any) {
    const res = await http.get("api/services/app/PaymentPhase/GetAll", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async getAllPeriod(params: any) {
    const res = await http.get("api/services/app/PaymentPeriod/GetAll", {
      params,
    })
    const { result } = res.data
    return result
  }
}

export default new PaymentMasterService()
